import { message } from "antd";
import axios from "axios";

const baseURL =
  window.location.hostname === "www.w2st.net"
    ? process.env.REACT_APP_PROD_URL
    : process.env.REACT_APP_BASE_URL;

export const axiosInstance = axios.create({
  baseURL: baseURL,
});

// --- Request interceptor ---
axiosInstance.interceptors.request.use(
  async (config: any) => {
    try {
      if (typeof window !== "undefined") {
        const stringifyToken = localStorage.getItem("W2ST_STUDENT_TOKEN");

        const tokenParsed = stringifyToken
          ? JSON.parse(stringifyToken).accessToken
          : null;

        if (tokenParsed && typeof tokenParsed === "string" && config.headers) {
          if (!config.headers.Authorization && !config.headers.authorization) {
            config.headers.authorization = `Bearer ${tokenParsed}`;
          }
        }
      }
    } catch (error) {
      console.error("Error parsing token:", error);
    }
    return config;
  },
  async (error) => {
    if (typeof window !== "undefined") {
      message.error("Request error: " + error.message);
    }
    return Promise.reject(error);
  }
);

// --- Response interceptor ---
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (typeof window !== "undefined" && error.response) {
      const { status } = error.response;
      if (status === 401 || status === 440) {
        localStorage.removeItem("W2ST_STUDENT_TOKEN");
        localStorage.removeItem("hasSeenWelcomeLoader");
        message.success("Session expired, proceed to login");
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);
